module.exports = __webpack_public_path__ + "static/img/card4.4ce76b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/card4.png
// module id = iFHf
// module chunks = 2